export default __webpack_public_path__ + "static/media/visi-alert-circle.01a43e68.svg";